"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.missionDocumentSchema = void 0;
const yup = __importStar(require("yup"));
const mission_document_type_enum_1 = require("../../enums/mission-document-type.enum");
const afto_781_v1_data_schema_1 = require("./afto_781_v1-data/afto_781_v1-data.schema");
exports.missionDocumentSchema = yup.object().shape({
    id: yup.string().nullable().optional(),
    type: yup.string().oneOf(Object.values(mission_document_type_enum_1.MissionDocumentType)).required(),
    isLocked: yup.boolean().nullable().optional(),
    eventId: yup.string().nullable().optional(),
    data: yup.lazy((missionDocument) => {
        switch (missionDocument === null || missionDocument === void 0 ? void 0 : missionDocument.type) {
            case mission_document_type_enum_1.MissionDocumentType.AFTO_781_V1:
                return afto_781_v1_data_schema_1.afto781V1DataSchema;
            default:
                return yup.object().shape({}).nullable();
        }
    }),
});
